import React, { useState, useContext } from "react";

//External
import _ from "lodash";

// Material-UI
import { makeStyles } from "@material-ui/core/styles";

// Components
import { ModuleWrapperContext } from "@Components/ModuleWrapper/ModuleWrapperContext";

// Styles
import { moduleListing } from "@Styles/ModuleListing";

// Internal
import Language from "sccLanguage";
import FeedsForm from "./FeedsForm";
import FeedsList from "./FeedsList";

const useStyles = makeStyles((theme) => ({
  ...moduleListing(theme),
}));

const MW_LIST_MODE = process.env.REACT_APP_MW_LIST_MODE;

function ModuleWrapperFeedsBody(props) {
  const [mwState] = useContext(ModuleWrapperContext);
  const [openDetailsFor, setOpenDetailsFor] = useState(null);
  const filteredModuleData = mwState.convertAndSort(
    mwState.filteredModuleData,
    mwState.searchField
  );

  const handleClick = (id) => {
    openDetailsFor !== id ? setOpenDetailsFor(id) : setOpenDetailsFor(null);
  };

  const classes = useStyles();

  return mwState.wrapperDisplayMode === MW_LIST_MODE ? (
    <ul className={classes.listContainer}>
      {!_.isEmpty(filteredModuleData) ? (
        filteredModuleData
          .slice(mwState.pagination.startIndex, mwState.pagination.endIndex)
          .map((data) => {
            return (
              <FeedsList
                key={data.id}
                data={data}
                handleClick={handleClick}
                openDetailsFor={openDetailsFor}
              />
            );
          })
      ) : (
        <div className="noResults">{Language.translate("No Results!")}</div>
      )}
    </ul>
  ) : (
    <FeedsForm />
  );
}

export default ModuleWrapperFeedsBody;